import validObj from './validateObj';
import store from './../store';

export default e => {
    let mappedValues = {};
    let formObj;
    Object.keys(e).forEach(item => {
        if (e[item].value) {
            if (item === 'aaRecommend') {
                mappedValues['recommend'] = e[item].value;
            } else if (item === 'aadeliverable') {
                mappedValues['deliverable'] = e[item].value;
            } else if (item === 'aaApproverId') {
                mappedValues['approverId'] = e[item].value;
            } else {
                mappedValues[item] = e[item].value;
            }
        }

        if (item === 'PromotionalItem') {
            mappedValues[
                'PromotionalItem'
            ] = store.getState().event.PromotionalItem;
        }
    });

    formObj = validObj(mappedValues);
    formObj.id = formObj.reportId;

    return formObj;
};



// WEBPACK FOOTER //
// ./src/helpers/afterActionSave.js